import { useTranslation } from 'react-i18next'
import './international-payment.component.scoped.scss'

export default () => {
  const [t] = useTranslation('internationalPayment')

  return (
    <div className={'international-payment mb-5'}>
      <h5 className="mb-5">{t('title')}</h5>
      <section className="cards">
        <div className="my-card">
          <i className="fa-regular fa-receipt card-icon" style={{ color: 'var(--text_color)' }}></i>
          <p>{t('cardInfos.first')}</p>
        </div>
        <i className="fa-solid fa-arrow-right arrow" style={{ color: 'var(--gray)' }}></i>
        <div className="my-card">
          <i className="fa-regular fa-building-columns card-icon" style={{ color: 'var(--text_color)' }}></i>
          <p>{t('cardInfos.second')}</p>
        </div>
        <i className="fa-solid fa-arrow-right arrow" style={{ color: 'var(--gray)' }}></i>
        <div className="my-card">
          <i className="fa-regular fa-money-bill card-icon" style={{ color: 'var(--text_color)' }}></i>
          <p>{t('cardInfos.third')}</p>
        </div>
      </section>
      <hr />
      <section className="mandatory-data">
        <p className="mb-3" dangerouslySetInnerHTML={{ __html: t('mandatoryData.title') }} />
        <ol>
          <li>{t('mandatoryData.first')}</li>
          <li>{t('mandatoryData.second')}</li>
          <li>{t('mandatoryData.third')}</li>
          <li>{t('mandatoryData.fourth')}</li>
          <li>{t('mandatoryData.fifth')}</li>
        </ol>
        <p className="mt-3" dangerouslySetInnerHTML={{ __html: t('mandatoryData.doubt') }} />
      </section>
    </div>
  )
}
